import { CurrentPage, FormField } from './new-shipment.types';
import { OrgTypes } from 'src/Library/Constants';
import { termsConditionsPlaceholder } from '../../Enquiry/InquiryUtils';

export const initialState = {
  currentPage: CurrentPage.FIRST,
  visited: {
    FIRST: true,
    SECOND: false,
    THIRD: false,
  },
};

export const ButtonNames = {
  PREV: 'Previous',
  NEXT: 'Next',
  SUBMIT: 'Submit',
};

export const TabNames = {
  FIRST: 'Shipping Details',
  SECOND: 'Services & Address',
  THIRD: 'Order Details',
};

export const TabDescription = {
  FIRST: 'Enter the port details, movement, cargo & dimensions',
  SECOND: 'Enter the service details, addresses and T&C',
  THIRD: 'Enter the details of the Stakeholders and the order.',
};

export const formItemLayout = {
  colon: false,
  required: false,
};

export const ShipmentFormFields: Record<string, FormField> = {
  BOOKINGNUMBER: {
    configKey: '',
    key: 'bookingNumber',
    required: false,
    label: 'Shipsy Booking Id',
    placeholder: 'Search Booking',
    disableKey: 'disableBooking',
    step: CurrentPage.FIRST,
  },
  BLNUMBER: {
    configKey: 'SECE9',
    key: 'blNumber',
    required: false,
    label: 'BL Number',
    placeholder: 'Enter BL Number',
    disableKey: 'blNumberDisabled',
    step: CurrentPage.SECOND,
  },
  CUSTOMER: {
    configKey: 'SECE32',
    key: 'customerIds',
    required: false,
    label: 'Customer',
    placeholder: 'Search & Select Customer',
    stakeholderType: OrgTypes.CUSTOMER,
    step: CurrentPage.THIRD,
  },
  SUPPLIER: {
    configKey: 'SECE44',
    key: 'supplierIds',
    required: false,
    label: 'Supplier',
    placeholder: 'Search & Select Supplier',
    stakeholderType: OrgTypes.SUPPLIER,
    step: CurrentPage.THIRD,
  },
  FF: {
    configKey: 'SECE33',
    key: 'ffId',
    required: false,
    label: 'FF',
    placeholder: 'Search & Select FF',
    stakeholderType: OrgTypes.FF,
    step: CurrentPage.THIRD,
  },
  PARENT: {
    configKey: '',
    key: 'parentId',
    required: false,
    label: 'Parent',
    placeholder: 'Search & Select Parent',
    stakeholderType: OrgTypes.PARENT,
    step: CurrentPage.THIRD,
  },
  CHILD: {
    configKey: '',
    key: 'childId',
    required: false,
    label: 'Child',
    placeholder: 'Search & Select Child',
    stakeholderType: OrgTypes.CHILD,
    step: CurrentPage.THIRD,
  },
  CHA: {
    configKey: 'SECE34',
    key: 'chaId',
    required: false,
    label: 'CHA',
    placeholder: 'Search & Select CHA',
    stakeholderType: OrgTypes.CHA,
    step: CurrentPage.THIRD,
  },
  TRANSPORTER: {
    configKey: 'SECE35',
    key: 'transporterId',
    required: false,
    label: 'Transporter',
    placeholder: 'Search & Select Transporter',
    stakeholderType: OrgTypes.TRANSPORTER,
    step: CurrentPage.THIRD,
  },
  CFS: {
    configKey: 'SECE53',
    key: 'cfsContractorId',
    required: false,
    label: 'CFS Contractor',
    placeholder: 'Search & Select CFS Contractor',
    stakeholderType: OrgTypes.CFS_CONTRACTOR,
    step: CurrentPage.THIRD,
  },
  ICD: {
    configKey: 'SECE54',
    key: 'icdContractorId',
    required: false,
    label: 'ICD Contractor',
    placeholder: 'Search & Select ICD Contractor',
    stakeholderType: OrgTypes.ICD_CONTRACTOR,
    step: CurrentPage.THIRD,
  },
  SURVEYOR: {
    configKey: 'SECE55',
    key: 'surveyorId',
    required: false,
    label: 'Surveyor',
    placeholder: 'Search & Select Surveyor',
    stakeholderType: OrgTypes.SURVEYOR,
    step: CurrentPage.THIRD,
  },
  BREAK_BULK: {
    configKey: 'SECE56',
    key: 'breakBulkId',
    required: false,
    label: 'Break Bulk',
    placeholder: 'Search & Select Break Bulk',
    stakeholderType: OrgTypes.BREAK_BULK,
    step: CurrentPage.THIRD,
  },
  INTER_CARTING: {
    configKey: 'SECE57',
    key: 'interCartingId',
    required: false,
    label: 'Inter Carting',
    placeholder: 'Search & Select Inter Carting',
    stakeholderType: OrgTypes.INTER_CARTING,
    step: CurrentPage.THIRD,
  },
  PURCHASE: {
    configKey: 'SECE36',
    key: 'purchaseOrderNumberList',
    required: false,
    label: 'Purchase Order#',
    placeholder: 'Enter Purchase Order#',
    step: CurrentPage.THIRD,
  },
  INTERNAL: {
    configKey: 'SECE40',
    key: 'clientReferenceNumber',
    required: false,
    label: 'Internal Reference#',
    placeholder: 'Enter Internal Reference#',
    step: CurrentPage.THIRD,
  },
  SALES: {
    configKey: 'SECE37',
    key: 'salesOrderNumber',
    required: false,
    label: 'Sales Order#',
    placeholder: 'Enter Sales Order#',
    step: CurrentPage.THIRD,
  },
  INVOICE: {
    configKey: 'SECE38',
    key: 'invoiceNumberList',
    required: false,
    label: 'Invoice#',
    placeholder: 'Enter Invoice#',
    step: CurrentPage.THIRD,
  },
  PLANT: {
    configKey: 'SECE39',
    key: 'plantId',
    required: false,
    label: 'Plant',
    placeholder: 'Search & Select Plant',
    step: CurrentPage.THIRD,
  },
  ORIGIN_SERVICE: {
    configKey: 'SECE24',
    key: 'originServices',
    label: 'Origin Services',
    required: false,
    disableKey: 'originServicesDisabled',
    step: CurrentPage.SECOND,
  },
  DESTINATION_SERVICE: {
    configKey: 'SECE25',
    key: 'destinationServices',
    label: 'Destination Services',
    disableKey: 'destinationServicesDisabled',
    step: CurrentPage.SECOND,
  },
  PICKUP: {
    configKey: 'SECE26',
    key: 'pickupAndDrop',
    label: 'Pickup & Drop',
    placeholder: 'Select Pickup & Drop',
    step: CurrentPage.SECOND,
  },
  ORIGIN_ADDRESS: {
    configKey: 'SECE27',
    key: 'originAddress',
    label: 'Origin Address',
    placeholder: 'Origin Address',
    step: CurrentPage.SECOND,
  },
  DESTINATION_ADDRESS: {
    configKey: 'SECE28',
    key: 'destinationAddress',
    label: 'Destination Address',
    placeholder: 'Destination Address',
    step: CurrentPage.SECOND,
  },
  LOADING: {
    configKey: 'SECE29',
    key: 'originLocationType',
    label: 'Loading',
    placeholder: 'Select Loading Location',
    step: CurrentPage.SECOND,
  },
  UNLOADING: {
    configKey: 'SECE30',
    key: 'destinationLocationType',
    label: 'Unloading',
    placeholder: 'Select Unloading Location',
    step: CurrentPage.SECOND,
  },
  LOADINGLOCATION: {
    configKey: 'SECE46',
    key: 'originLocationId',
    label: 'Stuffing Location',
    placeholder: 'Select Stuffing Location',
    addressType: 'STUFFING',
    step: CurrentPage.SECOND,
  },
  UNLOADINGLOCATION: {
    configKey: 'SECE47',
    key: 'destinationLocationId',
    label: 'De-stuffing Location',
    placeholder: 'Select De-stuffing Location',
    addressType: 'DESTUFFING',
    step: CurrentPage.SECOND,
  },
  TNC: {
    configKey: 'SECE31',
    key: 'termsAndConditions',
    label: 'Terms & Conditions',
    placeholder: termsConditionsPlaceholder,
    required: false,
    step: CurrentPage.SECOND,
  },
  MODE: {
    configKey: 'SECE0',
    key: 'mode',
    label: 'Mode',
    required: true,
    placeholder: 'Select Mode',
    step: CurrentPage.FIRST,
  },
  INCOTERM: {
    configKey: 'SECE0',
    key: 'incoterm',
    label: 'Incoterm',
    required: true,
    placeholder: 'Select Incoterm',
    step: CurrentPage.FIRST,
  },
  MOVEMENT: {
    configKey: 'SECE0',
    key: 'type',
    label: 'Type',
    required: true,
    placeholder: 'Select Type',
    step: CurrentPage.FIRST,
  },
  CARRIER: {
    configKey: 'SECE45',
    key: 'carrierCode',
    label: 'Carrier',
    required: false,
    placeholder: 'Select Carrier',
    step: CurrentPage.FIRST,
  },
  ORIGIN_PORT: {
    configKey: 'SECE1',
    key: 'originPortCode',
    label: 'Origin',
    placeholder: 'Select Origin Port',
    countryKey: 'originCountryCode',
    disableKey: 'originPortDisabled',
    required: true,
    step: CurrentPage.FIRST,
  },
  POL: {
    configKey: 'SECE5',
    key: 'originPolCode',
    label: 'Port of Loading',
    placeholder: 'Select POL',
    disableKey: 'polDisabled',
    step: CurrentPage.FIRST,
  },
  POD: {
    configKey: 'SECE6',
    key: 'destinationPodCode',
    label: 'Port of Destination',
    placeholder: 'Select POD',
    disableKey: 'podDisabled',
    step: CurrentPage.FIRST,
  },
  DESTINATION_PORT: {
    configKey: 'SECE2',
    key: 'destinationPortCode',
    label: 'Destination',
    placeholder: 'Select Destination Port',
    countryKey: 'destinationCountryCode',
    disableKey: 'destinationPortDisabled',
    required: true,
    step: CurrentPage.FIRST,
  },
  ORIGIN_COUNTRY: {
    configKey: 'SECE3',
    key: 'originCountryCode',
    label: 'Origin Country',
    placeholder: 'Select Origin Country',
    disableKey: 'originCountryDisabled',
    required: true,
    step: CurrentPage.FIRST,
  },
  DESTINATION_COUNTRY: {
    configKey: 'SECE4',
    key: 'destinationCountryCode',
    label: 'Destination Country',
    placeholder: 'Select Destination Country',
    disableKey: 'destinationCountryDisabled',
    required: true,
    step: CurrentPage.FIRST,
  },
  ACCESS: {
    configKey: '',
    key: 'accessType',
    label: 'Shipment Access',
    placeholder: 'Select Access',
    required: true,
    step: CurrentPage.FIRST,
  },
  TEAM: {
    configKey: '',
    key: 'teamIds',
    label: 'Select Team',
    placeholder: 'Select Team',
    required: true,
    step: CurrentPage.FIRST,
  },
  WATCHER: {
    configKey: '',
    key: 'watcherList',
    label: 'Watcher(s)',
    placeholder: 'Write e-mail IDs to add watchers',
    required: false,
    step: CurrentPage.FIRST,
  },
  CARGO: {
    configKey: 'SECE7',
    key: 'cargoType',
    label: 'Cargo',
    placeholder: 'Select Cargo Type',
    required: true,
    step: CurrentPage.FIRST,
  },
  SUB_CARGO: {
    configKey: 'SECE8',
    key: 'cargoSubtype',
    label: 'Sub Cargo',
    required: true,
    placeholder: 'Select Sub Cargo Type',
    step: CurrentPage.FIRST,
  },
  STACKABLE: {
    configKey: 'SECE10',
    key: 'stackable',
    label: 'Stackable',
    required: false,
    step: CurrentPage.FIRST,
  },
  PRODUCT: {
    configKey: '',
    key: 'productDetails',
    label: 'Products',
    addMoreLabel: 'Add More Product',
    placeholder: 'Select Products',
    disableKey: 'productDisabled',
    required: false,
    step: CurrentPage.FIRST,
  },
  CONTAINER: {
    configKey: '',
    key: 'packagingDetails',
    label: 'Containers',
    addMoreLabel: 'Add More Container',
    disableKey: 'containerDisabled',
    step: CurrentPage.FIRST,
  },
};

/**
 * Optional fields a user can clear on an existing shipment.
 *
 * When one of these is emptied during an edit, the payload must carry an
 * explicit `null` — not `undefined` — so the backend's PUT /execution/:id
 * receives a "clear this" instruction. `undefined` is dropped by JSON.stringify,
 * the key never reaches the backend, and the merge in Helper.updateObj retains
 * the old value (the field reappears on refresh). For stakeholder fields, sending
 * `null` also lets the backend remove the stale resource-sharing/access entry.
 *
 * Membership rules (why this list and not "every empty field"):
 *  - The field is a user-editable, OPTIONAL input (required: false) — a required
 *    field that is empty is already blocked client-side by the required-field
 *    validation in getApiBody/checkForErrors, so it never reaches the backend
 *    empty. That validation is the backstop that makes clearing these safe.
 *  - It maps to a NULLABLE column the edit endpoint persists. List fields
 *    (invoice/PO/customer/supplier/watcher) are excluded because an empty array
 *    is already truthy and sent correctly — they never hit this bug.
 *  - It is not an alias of another column (see road-mode Transporter below) and
 *    not a link with cascade semantics (parent/child shipment) or a
 *    booking/BL-linked field.
 *
 * See ISS-291273.
 */
export const CLEARABLE_ON_EDIT_FIELD_KEYS: string[] = [
  ShipmentFormFields.FF.key, // ffId
  ShipmentFormFields.CHA.key, // chaId
  ShipmentFormFields.TRANSPORTER.key, // transporterId (except road modes — see below)
  ShipmentFormFields.SALES.key, // salesOrderNumber
  ShipmentFormFields.INTERNAL.key, // clientReferenceNumber (Internal Reference#)
  ShipmentFormFields.PLANT.key, // plantId
];

/**
 * In DOMESTIC / RPTL (road) modes the Transporter field is a display alias of the
 * ff_id column (see NewShipmentHelper.convertEditdata), which is also mandatory in
 * those modes. Nulling it would orphan transporter_id while ff_id survives, so the
 * value reappears on reopen — an inconsistent partial clear. Clearing is therefore
 * a no-op for these keys in road modes. See ISS-291273 (Codex P1).
 */
export const ROAD_MODE_NON_CLEARABLE_FIELD_KEYS: string[] = [
  ShipmentFormFields.TRANSPORTER.key,
];

export const ProductFormFieldExtraKeys = {
  PRODUCT_NAME: {
    configKey: 'SECE11',
    key: 'key',
    required: ShipmentFormFields.PRODUCT.required,
    step: CurrentPage.FIRST,
  },
  PRODUCT_COUNT: {
    configKey: 'SECE12',
    key: 'quantity',
    required: ShipmentFormFields.PRODUCT.required,
    step: CurrentPage.FIRST,
  },
  PRODUCT_UNIT: {
    configKey: 'SECE13',
    key: 'unit',
    required: ShipmentFormFields.PRODUCT.required,
    step: CurrentPage.FIRST,
  },
  PRODUCT_CASES: {
    configKey: 'SECE51',
    key: 'cases',
    required: ShipmentFormFields.PRODUCT.required,
    step: CurrentPage.FIRST,
  },
  PRODUCT_SKU: {
    configKey: 'SECE52',
    key: 'skuClientNumber',
    required: ShipmentFormFields.PRODUCT.required,
    step: CurrentPage.FIRST,
  },
};

export const ContainerFormFieldExtraKeys = {
  CONTAINER_TYPE: {
    configKey: 'SECE14',
    key: 'type',
    required: true,
    step: CurrentPage.FIRST,
  },
  CONTAINER_COUNT: {
    configKey: 'SECE15',
    key: 'count',
    required: true,
    step: CurrentPage.FIRST,
  },
  CONTAINER_LENGTH: {
    configKey: 'SECE16',
    key: 'length',
    step: CurrentPage.FIRST,
  },
  CONTAINER_BREADTH: {
    configKey: 'SECE17',
    key: 'breadth',
    step: CurrentPage.FIRST,
  },
  CONTAINER_HEIGHT: {
    configKey: 'SECE18',
    key: 'height',
    step: CurrentPage.FIRST,
  },
  CONTAINER_DIMENTION_UNIT: {
    configKey: 'SECE19',
    key: 'dimentionUnit',
    required: false,
    step: CurrentPage.FIRST,
  },
  CONTAINER_MIN_VOL: {
    configKey: 'SECE20',
    key: 'minVol',
    required: true,
    step: CurrentPage.FIRST,
  },
  CONTAINER_MIN_VOL_UNIT: {
    configKey: 'SECE21',
    key: 'minVolUnit',
    required: true,
    step: CurrentPage.FIRST,
  },
  CONTAINER_GROSS_WEIGHT: {
    configKey: 'SECE22',
    key: 'grossWeight',
    required: false,
    step: CurrentPage.FIRST,
  },
  CONTAINER_GROSS_WEIGHT_UNIT: {
    configKey: 'SECE23',
    key: 'grossWeightUnit',
    step: CurrentPage.FIRST,
  },
  CONTAINER_SIZE: {
    configKey: 'SECE41',
    key: 'size',
    required: true,
    step: CurrentPage.FIRST,
  },
  CONTAINER_TOTAL_WEIGHT: {
    configKey: 'SECE42',
    key: 'totalWeight',
    required: false,
    step: CurrentPage.FIRST,
  },
  CONTAINER_TOTAL_WEIGHT_UNIT: {
    configKey: 'SECE43',
    key: 'totalWeightUnit',
    required: false,
    step: CurrentPage.FIRST,
  },
  CONTAINER_TEMPERATURE: {
    configKey: 'SECE48',
    key: 'temperature',
    required: true,
    step: CurrentPage.FIRST,
  }
};

export const ShipmentFormFieldsDomestic: Record<string, FormField> = {
  BOOKINGNUMBER: ShipmentFormFields.BOOKINGNUMBER,
  CUSTOMER: ShipmentFormFields.CUSTOMER,
  SUPPLIER: ShipmentFormFields.SUPPLIER,
  FF: ShipmentFormFields.FF,
  CHA: ShipmentFormFields.CHA,
  TRANSPORTER: ShipmentFormFields.TRANSPORTER,
  CFS: ShipmentFormFields.CFS,
  ICD: ShipmentFormFields.ICD,
  BREAK_BULK: ShipmentFormFields.BREAK_BULK,
  SURVEYOR: ShipmentFormFields.SURVEYOR,
  INTER_CARTING: ShipmentFormFields.INTER_CARTING,
  PURCHASE: ShipmentFormFields.PURCHASE,
  INTERNAL: ShipmentFormFields.INTERNAL,
  SALES: ShipmentFormFields.SALES,
  INVOICE: ShipmentFormFields.INVOICE,
  TNC: ShipmentFormFields.TNC,
  MODE: ShipmentFormFields.MODE,
  INCOTERM: {
    ...ShipmentFormFields.INCOTERM,
    required: false,
  },
  MOVEMENT: ShipmentFormFields.MOVEMENT,
  CARRIER: ShipmentFormFields.CARRIER,
  LOADINGLOCATION: {
    ...ShipmentFormFields.LOADINGLOCATION,
    label: 'Origin (Stuffing Location)',
    step: CurrentPage.FIRST,
  },
  UNLOADINGLOCATION: {
    ...ShipmentFormFields.UNLOADINGLOCATION,
    label: 'Destination (De-stuffing Location)',
    step: CurrentPage.FIRST,
  },
  ORIGIN_COUNTRY: ShipmentFormFields.ORIGIN_COUNTRY,
  DESTINATION_COUNTRY: ShipmentFormFields.DESTINATION_COUNTRY,
  ACCESS: ShipmentFormFields.ACCESS,
  TEAM: ShipmentFormFields.TEAM,
  WATCHER: ShipmentFormFields.WATCHER,
  CARGO: ShipmentFormFields.CARGO,
  SUB_CARGO: {
    ...ShipmentFormFields.SUB_CARGO,
    required: false,
  },
  PRODUCT: ShipmentFormFields.PRODUCT,
  CONTAINER: ShipmentFormFields.CONTAINER,
};

export const ShipmentFormFieldsRPTL: Record<string, FormField> = {
  BOOKINGNUMBER: ShipmentFormFields.BOOKINGNUMBER,
  CUSTOMER: ShipmentFormFields.CUSTOMER,
  SUPPLIER: ShipmentFormFields.SUPPLIER,
  FF: ShipmentFormFields.FF,
  CHA: ShipmentFormFields.CHA,
  TRANSPORTER: ShipmentFormFields.TRANSPORTER,
  CFS: ShipmentFormFields.CFS,
  ICD: ShipmentFormFields.ICD,
  BREAK_BULK: ShipmentFormFields.BREAK_BULK,
  SURVEYOR: ShipmentFormFields.SURVEYOR,
  INTER_CARTING: ShipmentFormFields.INTER_CARTING,
  PURCHASE: ShipmentFormFields.PURCHASE,
  INTERNAL: ShipmentFormFields.INTERNAL,
  SALES: ShipmentFormFields.SALES,
  INVOICE: ShipmentFormFields.INVOICE,
  TNC: ShipmentFormFields.TNC,
  MODE: ShipmentFormFields.MODE,
  INCOTERM: {
    ...ShipmentFormFields.INCOTERM,
    required: false,
  },
  MOVEMENT: ShipmentFormFields.MOVEMENT,
  CARRIER: ShipmentFormFields.CARRIER,
  LOADINGLOCATION: {
    ...ShipmentFormFields.LOADINGLOCATION,
    label: 'Origin (Stuffing Location)',
    step: CurrentPage.FIRST,
  },
  UNLOADINGLOCATION: {
    ...ShipmentFormFields.UNLOADINGLOCATION,
    label: 'Destination (De-stuffing Location)',
    step: CurrentPage.FIRST,
  },
  ORIGIN_COUNTRY: ShipmentFormFields.ORIGIN_COUNTRY,
  DESTINATION_COUNTRY: ShipmentFormFields.DESTINATION_COUNTRY,
  ACCESS: ShipmentFormFields.ACCESS,
  TEAM: ShipmentFormFields.TEAM,
  WATCHER: ShipmentFormFields.WATCHER,
  CARGO: ShipmentFormFields.CARGO,
  SUB_CARGO: {
    ...ShipmentFormFields.SUB_CARGO,
    required: false,
  },
  PRODUCT: ShipmentFormFields.PRODUCT,
  CONTAINER: ShipmentFormFields.CONTAINER,
};
